import { CaretRightIcon } from "@phosphor-icons/react/dist/csr/CaretRight";
import { QuestionIcon } from "@phosphor-icons/react/dist/csr/Question";
import {
  CommandGroup,
  CommandItem,
  CommandShortcut,
} from "@volca/ui/components/ui/command";
import { useBusinessProducts } from "@/core/business/use-business-products";
import { searchHelp } from "@/help/search";
import { getAvailableHelpTopics } from "@/help/topics";
import { HelpGuideItem } from "./help-guide-item";

const MAX_GUIDES = 5;

export const HelpGroup = ({
  query,
  onBrowse,
  onGo,
}: {
  query: string;
  onBrowse: () => void;
  onGo: (to: string) => void;
}) => {
  const { settings } = useBusinessProducts();
  const guides = query.trim()
    ? searchHelp(getAvailableHelpTopics(settings), query).slice(0, MAX_GUIDES)
    : [];

  return (
    <CommandGroup heading="Help">
      <CommandItem value="search help guides" onSelect={onBrowse}>
        <QuestionIcon />
        <span>Search help</span>
        <CommandShortcut>
          <CaretRightIcon />
        </CommandShortcut>
      </CommandItem>
      {guides.map((guide) => (
        <HelpGuideItem key={guide.id} {...guide} query={query} onGo={onGo} />
      ))}
    </CommandGroup>
  );
};
